import React from 'react'
import { IconProps } from '../../../common/types'

const AppSupportIcon: React.FC<IconProps> = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.9489 9.56181C28.6155 7.89514 27.8555 5.94847 26.9489 5.00181L22.9488 1.00181C21.2689 -0.66486 19.3355 0.0951397 18.3889 1.00181L16.1222 3.28181H12.6689C10.1355 3.28181 8.66885 4.61514 7.92218 6.14847L2.00218 12.0685V17.4018L1.05552 18.3351C-0.611149 20.0151 0.148851 21.9485 1.05552 22.8951L5.05552 26.8951C5.77552 27.6151 6.54885 27.8818 7.28218 27.8818C8.22885 27.8818 9.09552 27.4151 9.61552 26.8951L13.2155 23.2818H18.0022C20.2689 23.2818 21.4155 21.8685 21.8289 20.4818C23.3355 20.0818 24.1622 18.9351 24.4955 17.8151C26.5622 17.2818 27.3355 15.3218 27.3355 13.9485V9.94847H26.5489L26.9489 9.56181ZM24.6688 13.9485C24.6688 14.5485 24.4155 15.2818 23.3355 15.2818H22.0022V16.6151C22.0022 17.2151 21.7489 17.9485 20.6689 17.9485H19.3355V19.2818C19.3355 19.8818 19.0822 20.6151 18.0022 20.6151H12.1222L7.74885 24.9885C7.33552 25.3751 7.09552 25.1485 6.94885 25.0018L2.96218 21.0285C2.57552 20.6151 2.80218 20.3751 2.94885 20.2285L4.66885 18.4951V13.1618L7.33552 10.4951V12.6151C7.33552 14.2285 8.40218 16.6151 11.3355 16.6151C14.2689 16.6151 15.3355 14.2285 15.3355 12.6151H24.6688V13.9485ZM25.0555 7.66847L22.7889 9.94847H12.6689V12.6151C12.6689 13.2151 12.4155 13.9485 11.3355 13.9485C10.2555 13.9485 10.0022 13.2151 10.0022 12.6151V8.61514C10.0022 8.00181 10.2289 5.94847 12.6689 5.94847H17.2155L20.2555 2.90847C20.6689 2.52181 20.9089 2.74847 21.0555 2.89514L25.0422 6.86847C25.4289 7.28181 25.2022 7.52181 25.0555 7.66847Z"
        fill="#998D8D"
      />
    </svg>
  )
}

export default AppSupportIcon
